// extracted by mini-css-extract-plugin
export var link = "_tf-0";